import { render, staticRenderFns } from "./vehicleDetail.vue?vue&type=template&id=fe4dbe06&scoped=true"
import script from "./vehicleDetail.vue?vue&type=script&lang=js"
export * from "./vehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleDetail.vue?vue&type=style&index=0&id=fe4dbe06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4dbe06",
  null
  
)

export default component.exports